import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    AuthApiService
} from '@spa/api';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RedirectLoginService implements CanActivate {
    constructor(
        private authApiService: AuthApiService,
        protected router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authApiService
            .loginRedirect()
            .pipe(
                map((response: ApiResponse<ApiError[] | boolean>) => {
                    if (response.status !== HttpStatusCodesEnum.Ok) {
                        this.router
                            .navigate(['/error'], {
                                state: {
                                    statuses: HttpStatusCodesEnum.InternalServerError,
                                    messages: 'Internal server error'
                                }
                            })
                            .finally();
                    }

                    return false;
                })
            );
    }
}
